import { Skull } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

interface StatusPillProps {
  label: string;
  ok: boolean;
}

function StatusPill({ label, ok }: StatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs",
        ok ? "bg-emerald-500/10 text-emerald-400" : "bg-red-500/10 text-red-400",
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", ok ? "bg-emerald-400" : "bg-red-400")} />
      {label}
    </span>
  );
}

export function TopBar() {
  const { t } = useTranslation("common");

  return (
    <header className="flex h-14 items-center justify-between border-b bg-card px-4">
      <div className="flex items-center gap-3">
        <span className="text-lg font-semibold">beup2date</span>
        <span className="text-xs text-muted-foreground">{t("topBar.version")}</span>
      </div>

      <div className="flex items-center gap-2">
        <StatusPill label={t("topBar.status.ibkrPaper")} ok={true} />
        <StatusPill label={t("topBar.status.liveOff")} ok={false} />
        <StatusPill label={t("topBar.status.feeds")} ok={true} />
        <StatusPill label={t("topBar.status.agents")} ok={true} />
      </div>

      <div className="flex items-center gap-4">
        <div className="text-sm">
          {t("topBar.plToday")} <span className="text-emerald-400">+0.00 €</span>
        </div>
        <button
          type="button"
          className={cn(
            "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium",
            "bg-red-600 text-white hover:bg-red-700",
          )}
          onClick={() => {
            // TODO Phase 2: confirmation modal + POST /admin/kill-switch
          }}
        >
          <Skull className="h-4 w-4" />
          {t("topBar.killSwitch")}
        </button>
      </div>
    </header>
  );
}
